var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdministration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Administration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#777775;}\r\n\t.st1{opacity:0.2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikon_5_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,41c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4 c-2.3,1.1-3.9,3.4-3.9,6.1c0,0.7,0.6,1.4,1.4,1.4H39c0.7,0,1.4-0.6,1.4-1.4C40.4,44.4,38.8,42,36.5,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,32.9c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4c-3,0-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4 c-2.3,1.1-3.9,3.4-3.9,6.1c0,0.7,0.6,1.4,1.4,1.4h13.5c0.7,0,1.4-0.6,1.4-1.4C59.3,36.3,57.7,33.9,55.4,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.3,48.4h13.5c0.7,0,1.4-0.6,1.4-1.4c0-2.7-1.6-5-3.9-6.1c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4 s-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4C63.6,42,62,44.4,62,47.1C62,47.8,62.6,48.4,63.3,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,59.9c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4 c-2.3,1.1-3.9,3.4-3.9,6.1c0,0.7,0.6,1.4,1.4,1.4H39c0.7,0,1.4-0.6,1.4-1.4C40.4,63.3,38.8,61,36.5,59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,70.7c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4c-3,0-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4 c-2.3,1.1-3.9,3.4-3.9,6.1c0,0.7,0.6,1.4,1.4,1.4h13.5c0.7,0,1.4-0.6,1.4-1.4C59.3,74.1,57.7,71.8,55.4,70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.3,59.9c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4 C63.6,61,62,63.3,62,66c0,0.7,0.6,1.4,1.4,1.4h13.5c0.7,0,1.4-0.6,1.4-1.4C78.2,63.3,76.6,61,74.3,59.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.5,41.9c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4 c-2.3,1.1-3.9,3.4-3.9,6.1c0,0.7,0.6,1.4,1.4,1.4h13.5c0.7,0,1.4-0.6,1.4-1.4C39.4,45.3,37.8,43,35.5,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.4,33.8c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4c-3,0-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4 c-2.3,1.1-3.9,3.4-3.9,6.1c0,0.7,0.6,1.4,1.4,1.4H57c0.7,0,1.4-0.6,1.4-1.4C58.3,37.2,56.7,34.9,54.4,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.4,49.3h13.5c0.7,0,1.4-0.6,1.4-1.4c0-2.7-1.6-5-3.9-6.1c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4 s-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4C62.6,43,61,45.3,61,48C61,48.7,61.6,49.3,62.4,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.5,60.8c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4 c-2.3,1.1-3.9,3.4-3.9,6.1c0,0.7,0.6,1.4,1.4,1.4h13.5c0.7,0,1.4-0.6,1.4-1.4C39.4,64.2,37.8,61.9,35.5,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.4,71.6c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4c-3,0-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4 c-2.3,1.1-3.9,3.4-3.9,6.1c0,0.7,0.6,1.4,1.4,1.4H57c0.7,0,1.4-0.6,1.4-1.4C58.3,75,56.7,72.7,54.4,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.3,60.8c0.7-0.9,1.2-2.1,1.2-3.4c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4c0,1.3,0.5,2.4,1.2,3.4 c-2.3,1.1-3.9,3.4-3.9,6.1c0,0.7,0.6,1.4,1.4,1.4h13.5c0.7,0,1.4-0.6,1.4-1.4C77.2,64.2,75.6,61.9,73.3,60.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/Administration.49bdaa2ba8223f7fedbd9ec629839281.svg";
export { ForwardRef as ReactComponent };